import type { CSSProperties } from 'react'

// One name clamp for the per-objective tables and print (I6 §6.1, Note 4):
// the full name on at most two lines, never a one-line ellipsis; the full
// text is also in `title` for the narrow case.
export function ObjectiveName({ name, className = '', style }: { name: string; className?: string; style?: CSSProperties }) {
  return (
    <span className={`rd-objective-name ${className}`} title={name} style={style}>
      {name}
    </span>
  )
}
